import store from '../store';

import { logError } from 'shared-services/logger-service';
import { delay } from 'utils/helpers';

const DEFAULT_FETCH_LIMIT = 100;

export const dispatchPromise = ({ type, payload, preventSave }) => {
    return new Promise((resolve, reject) => {
        try {
            store.dispatch({
                type,
                payload,
                preventSave,
                onComplete: resolve,
                onError: reject
            });
        } catch (e) {
            logError('action', e, { type, payload });
        }
    });
}

const doFetchResources = async (type, fetchProps, offset, limit, recursive, withDelay, allData = []) => {
    const response = await dispatchPromise({
        type,
        payload: {
            ...fetchProps,
            offset,
            limit
        }
    });

    if (response && response.hasMore && recursive) {
        if (withDelay) {
            await delay(50);
        }

        const key = Object.keys(response).find(key => Array.isArray(response[key]));
        return doFetchResources(type, fetchProps, offset + limit, limit, recursive, [...allData, ...response[key]]);
    }

    return response;
}

export const fetchResources = (type, fetchProps = {}, all = true) => {
    const offset = fetchProps.offset || 0
    const limit = fetchProps.limit || DEFAULT_FETCH_LIMIT;
    return doFetchResources(type, fetchProps, offset, limit, all);
}
